/* eslint-disable no-unused-vars */
import ApiService from "../../api.service";
import appConfig from "../../../../app-config";
import { TokenStorage } from "../../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const ProductCategory1Service = {
    /**
     * Get Screen data
     *
     * */
    async getByCode (code) {
        const requestScreenData = {
            url: "api/ProductCategory1",
            top: "1",
            filter: `Code eq '${code}'`,
        };

        return await ApiService.oDataGet(requestScreenData);
    },
    dataSourceConfig (url, params) {
        return ApiService.createDataSource(url, params);
    },
    async save (mode, ProductCategory1) {
        var payload = ProductCategory1;
        var url = "api/ProductCategory1";

        if (mode == "create") {
            return await ApiService.post(
                url,
                payload,
                "String"
            );
        }
        else {
            return await ApiService.patch(url, ProductCategory1.Code, payload, "String");
        }
    },
};

export { ProductCategory1Service };
